'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _httpRequest = require('@souche-f2e/http-request');

var _httpRequest2 = _interopRequireDefault(_httpRequest);

var _helper = require('../helper');

var _helper2 = _interopRequireDefault(_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @desc 广点通上传
 */
var interfaceName = '/marketapi/marketAdvertiseApi/tencentTransformationDataUpload.json';
var clickId = false;
var clientId = '';
var sourceType = 'WEB';

var _doStatistics = function _doStatistics() {
    return _httpRequest2.default.ajax({
        url: _helper2.default.SERVERURL + interfaceName,
        type: 'post',
        data: {
            clientId: clientId,
            clickId: clickId,
            sourceType: sourceType,
            actionUrl: location.href,
            actionType: 'RESERVATION'
        }
    });
};

exports.default = {
    init: function init(id, id2) {
        clientId = id;
        clickId = id2;
    },
    doStatistics: function doStatistics() {
        //      if(clickId) {
        _doStatistics();
        //      }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/statistics/dist/channel/eqq.js
// module id = BcU6
// module chunks = 11